import React, { useEffect, useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import Table from 'components/Table/Table';
import moment from 'moment';
import RegularButton from 'components/CustomButtons/Button';
import { wsCreate } from 'services/WService';

function ConfirmModal(props) {
  const { model, setOpen, showNotify, reload } = props;
  const [sheets, setSheets] = useState(model.sheets || []);
  const [processing, setProcessing] = useState(false);

  async function confirm() {
    const selectedSheets = sheets.map(sheet => sheet.id);
    setProcessing(true);
    let res = await wsCreate('prog/sheet-distribution/massive-confirm', { sheet_distribution_ids: selectedSheets });
    setProcessing(false);

    if (res.success) {
      showNotify(res.message);
      setOpen({ open: false });
      reload();
    }else{
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    if ((model.sheets?.length || 0) === 0) setSheets([]);
    else setSheets(model.sheets);
  }, [model.sheets]);

  return (
    <ModalBase
      model={model}
      setOpen={setOpen}
      hideSave
      maxWidth="lg"
      title={`Confirmar ${sheets.length} hojas`}
      footerComponent={
        <RegularButton color="success" size="sm" onClick={confirm} disabled={processing}>
          Confirmar
        </RegularButton>
      }
    >
      <Table
        tableHead={['HR', 'Programado', 'Despacho', 'Vehículo', 'Enc Mercadería', 'Jefe Reparto']}
        tableData={sheets.map((sheet) => {
          return [
            sheet.id,
            moment(sheet.scheduled_date).format('DD/MM/YYYY'),
            // <TextField type="date" value={moment(sheet.dispatch_date).format('YYYY-MM-DD')} />,
            moment(sheet.dispatch_date).format('DD/MM/YYYY'),
            sheet.prog_vehicle_code,
            sheet.inventory_manager_name,
            sheet.manager_name,
          ];
        })}
      />
    </ModalBase>
  );
}

export default ConfirmModal;
